export const trackingEvents = {
  DESKTOP_EXTN_UNINSTALL_FEEDBACK_LANDING: 'DESKTOP_EXTN_UNINSTALL_FEEDBACK_LANDING',
  DESKTOP_EXTN_UNINSTALL_REINSTALL_CLICK: 'DESKTOP_EXTN_UNINSTALL_REINSTALL_CLICK',
  DESKTOP_EXTN_UNINSTALL_OPTION_CLICK: 'DESKTOP_EXTN_UNINSTALL_OPTION_CLICK',
  DESKTOP_EXTN_UNINSTALL_WRITE_INPUT_CLICK: 'DESKTOP_EXTN_UNINSTALL_WRITE_INPUT_CLICK',
  DESKTOP_EXTN_UNINSTALL_SUBMIT_CLICK: 'DESKTOP_EXTN_UNINSTALL_SUBMIT_CLICK',
  CONFIRM_ACCOUNT_VERIFICATION: 'CONFIRM_ACCOUNT_VERIFICATION'
};
